import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IConfigurationResponse, IDashboardMumPayload, IDashboardMumResponse, IPlace, IService } from 'src/app/models/dashboard.models';
import { IGenericResponse } from 'src/app/models/shared.models';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { EditProfileService } from 'src/app/services/edit-profile.service';
import { ImageUploadComponent } from '../shared-components/image-upload/image-upload.component';
import { DatePipe } from '@angular/common';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { HomeService } from 'src/app/services/home.service';
import { countryCodes } from 'src/app/constants/country';
import { environment } from 'src/environments/environment';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
@Component({
  selector: 'app-edit-profile-mum',
  templateUrl: './edit-profile-mum.component.html',
  styleUrls: ['./edit-profile-mum.component.scss']
})
export class EditProfileMumComponent implements OnInit {

  eye = true;

  @ViewChild('pass') pass: ElementRef;
  mum: IDashboardMumPayload;
  mumId: any;
  pictureUrl: any = '';

  photoBlog: any;
  loading = false;
  minDate = new Date().getFullYear();

  countries = countryCodes.countries;

  profileForm = new FormGroup({
    name: new FormControl('', Validators.required),
    userEmail: new FormControl('', Validators.required),
    userPhonenumber: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(13)]),
    countryCode: new FormControl('', Validators.required),
    address: new FormControl('', Validators.required),
    area: new FormControl('', Validators.required),
    age: new FormControl('', [Validators.required, Validators.min(15)]),
    newPassword: new FormControl('', Validators.minLength(6)),
    dueDate: new FormControl('', Validators.required),
  });

  @ViewChild(ImageUploadComponent) cameraComponent: ImageUploadComponent;

  areas: IService[];

  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  constructor(public authService: AuthService,
              public dashboardService: DashboardService,
              private editProfileService: EditProfileService,
              private datePipe: DatePipe,
              private homeService: HomeService,
              private snackBarService: SnackbarService) { }

  ngOnInit(): void {
    this.mumId = this.authService.getMumId();
    this.getMumDetail();
    this.getDropdownConfigurations();
    this.countries.forEach(country => {
      country.flag = environment.countryFlagUrl + country.code.toLowerCase() + '.svg';
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this.searchPlace(value)),
    );
  }

  // tslint:disable-next-line:typedef
  selectArea(value: any){
    this.profileForm.controls.address.setValue(value);
  }

  searchPlace(searchText: string): Array<string>{
    const body = {
      searchText
    };
    this.options = [];
    const sample: Array<string> = [];
    this.editProfileService.getPlaceSearchResults(body)
    .subscribe((res: Array<IPlace>) => {
      console.log('Search Places:', res);
      res.forEach(place => { sample.push(place.description); });
    }, err => {
      console.error('Search Places Error:', err);
    });
    this.options = sample;
    return this.options;
  }

  getMumDetail(): void{
    this.dashboardService.getMumById(this.mumId)
    .subscribe((res: IDashboardMumResponse) => {
      this.mum = res.payload;
      console.log('Mum Detail:', this.mum);
      this.setProfile(this.mum.profileImage);
      this.setData();
    }, err => {
      console.error('Fetch Mum Error:', err);
    });
  }

  toggle(option: string): void {
    this.eye = !this.eye;
    this.pass.nativeElement.type = this.eye ? 'password' : 'text';
  }

  setProfile(image: any): void{
    this.pictureUrl = image;
  }

  removeProfile(): void{
    this.pictureUrl = '';
  }

  setData(): void{
    this.profileForm.controls.name.setValue(this.mum.name);
    this.profileForm.controls.userEmail.setValue(this.mum.user[0].userEmail);
    this.profileForm.controls.userPhonenumber.setValue(this.mum.user[0].userPhonenumber);
    this.profileForm.controls.countryCode.setValue('+' + this.mum.user[0].countryCode);
    this.profileForm.controls.address.setValue(this.mum.address);
    this.myControl.setValue(this.mum.address);
    this.profileForm.controls.area.setValue(this.mum.area);
    this.profileForm.controls.age.setValue(this.mum.age);
    this.profileForm.controls.address.setValue(this.mum.address);
    this.profileForm.controls.dueDate.setValue(this.mum.dueDate);
  }

  updateProfile(): void{
    this.loading = true;
    const body = this.profileForm.value;
    body.dueDate = this.datePipe.transform(body.dueDate, 'yyyy-MM-dd');
    body.countryCode = body.countryCode.slice(1);

    if (body.newPassword.length === 0){
      delete body.newPassword;
    }

    this.editProfileService.updateProfileDetailMum(body)
    .subscribe((res: IDashboardMumResponse) => {
      console.log('Profile Updated :', res.payload);
      this.loading = false;
    }, err => {
      console.error('Profile Update Error:', err);
      this.loading = false;
    });

    // tslint:disable-next-line:triple-equals
    if (this.pictureUrl && this.pictureUrl != this.mum.profileImage)
    {
      this.loading = true;
      this.getBlob(this.pictureUrl).then(() => {
        const frmData = new FormData();
        frmData.append('file', this.photoBlog, this.mum.name + '.png');
        this.editProfileService.updateProfileImageMum(frmData)
        .subscribe((res: IGenericResponse) => {
          console.log('Profile Photo Updated !');
          this.loading = false;
        }, err => {
          console.error('Profile Photo Update Error:', err);
          this.snackBarService.openSnackBar(err.error.errorMessage, null, 'top');
          this.loading = false;
        });
      });
    }
  }

  getBlob(url: any): Promise<any>{
    return fetch(url)
    .then(res => res.blob())
    .then(res => { this.photoBlog = res; });
  }

  // tslint:disable-next-line:typedef
  openModal(type: string){
    // tslint:disable-next-line:triple-equals
    if (type === 'camera')
    {
      this.cameraComponent.webCamInit();
      this.cameraComponent.showCamera = true;
    }
    // tslint:disable-next-line:triple-equals
    else if (type === 'upload'){
      this.cameraComponent.showCamera = false;
    }
  }

  getDropdownConfigurations(): void{
    this.areas = [];
    this.homeService.getMiscConfiguration()
    .subscribe((res: IConfigurationResponse) => {
      this.areas = res.payload.serviceAreas;
    }, err => {
      console.error('Dropdown detail Error:', err);
    });
  }

}
